import { useEffect, useState } from 'react'
import { COLLECTION_2_0_EXPERIMENT_ID } from 'src/components/common/StatsigExposure/StatsigExposure'
import { Statsig } from 'src/sdk/statsig'
import { axiosClient } from 'src/services/axiosInstance'
import type { GetKitlooksResponse } from 'src/types/kitlooks'

import { KitlookWidgetContent } from './KitlookWidget'

interface KitlookCollectionCMSData {
  title: string
  buttonText?: string
  image: string
  productId: string
}

export function KitlookCollectionCMSWrapper({
  title,
  buttonText,
  image,
  productId,
}: KitlookCollectionCMSData) {
  const isEnabled = Statsig.useStatsigFeatureGateValue(
    COLLECTION_2_0_EXPERIMENT_ID
  )

  const [kitlookData, setKitlookData] = useState<GetKitlooksResponse | null>(
    null
  )

  useEffect(() => {
    if (!isEnabled) return

    const fetchData = async () => {
      const { data } = await axiosClient
        .post('/api/getKitlookInfo', {
          productIds: [productId],
        })
        .catch(() => ({ data: null }))

      if (!data) return

      setKitlookData(data.response)
    }

    fetchData()
  }, [isEnabled, productId])

  if (!isEnabled || !kitlookData?.kits?.length) return null

  return (
    <li className="col-span-1 h-full">
      <KitlookWidgetContent
        variant="collectionCMS"
        kitlooks={kitlookData.kits.slice(0, 1)}
        productId={productId}
        resumeOverrides={{
          title,
          image,
          buttonText,
        }}
      />
    </li>
  )
}
